import { useEffect } from "react";
import { useMatches } from "react-router";

type TitleHandle = {
  title?: string;
};

export default function TitleUpdater() {
  const matches = useMatches();

  useEffect(() => {
    const lastMatched = matches.reverse().find((match) => (match.handle as TitleHandle)?.title);

    if (lastMatched) {
      const title = (lastMatched.handle as TitleHandle).title;
      if (title) {
        document.title = title;
      }
    }
  }, [matches]);

  return null;
}
